import React from "react";
import { useNavigate } from "react-router-dom";
import { YellowButton } from "../../../components/Buttons";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedProduct } from "../../../api/reducers/selectedProductReducer";

const OrderProduct = ({ productItem }) => {
  const nav = useNavigate();
  const dispatch = useDispatch();
  const company = useSelector((state) => state.companyReducer.company);
  const selectedCompanyDomain = company.domain.type;

  const handleProductClick = () => {

    if (selectedCompanyDomain === "EDUCATION") {
      dispatch(setSelectedProduct(productItem));
      nav("/myCourses");
    } else {
      dispatch(setSelectedProduct(productItem));
      nav("/product-info");
    }
  };


  return (
    <div className="border-t p-4">
      <div className="flex max-w-2xl flex-col items-center rounded-md md:flex-row">
        <div className="h-full w-full md:h-[100px] md:w-[100px] text-xs">
          <img loading="lazy"
            src={productItem?.imageURL}
            alt={productItem?.name}
            className="h-full w-full rounded-md object-cover"
          />
        </div>

        <div className="p-4 capitalize">
          <button
            type="button"
            className="text-md mb-2 text-left text-sky-700 hover:text-sky-500 cursor-pointer"
            onClick={handleProductClick}
          >
            {productItem?.name}
          </button>

          <div className="mt-3 flex items-center space-x-4 text-sm capitalize">
            {selectedCompanyDomain !== "EDUCATION" && <YellowButton title="buy it again" />}
            {selectedCompanyDomain === 'EDUCATION' && (
              <button
                onClick={handleProductClick}
                className="px-4 py-2 text-white rounded"
                style={{ backgroundColor: 'var(--education-primary, #746EAC)' }}
              >
                View course
              </button>
            )}
          </div>

        </div>
      </div>
    </div>
  );
};

export default OrderProduct;
